import { queryOptions, useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import supplierQueryKeys from './supplierQueryKeys'
import { getSuppliers } from '../service/supplierService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Company } from '../../../types/company/Company'
import { Supplier } from '../../../types/supplier/supplier'

export const useSuppliers = <TData = Supplier[]>(companyId?: Company['id'], select?: (data: Supplier[]) => TData) =>
  useQuery(
    queryOptions({
      queryKey: supplierQueryKeys.list({ companyId }),
      queryFn: getSuppliers,
      enabled: !!companyId,
      gcTime: 15 * 60 * 1000,
      select: data => {
        const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name))
        return select ? select(sorted) : (sorted as TData)
      }
    })
  )

export const useCtxSuppliers = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useSuppliers(companyId)
}
